<!-- Desktop footer - unchanged -->
<footer class="hidden lg:flex fixed bottom-0 z-40 left-0 w-full px-6 p-3 bg-gray-50 border-t border-default shadow-sm items-center justify-between dark:bg-gray-800">
  <div class="grid grid-cols-4 w-full gap-8">
    @for (level of levels; track level) {
      <div cdkDropList
           [id]="'compare-' + level"
           [cdkDropListConnectedTo]="getConnectedLists(level)"
           cdkDropListAutoScrollDisabled
           cdkDropListHasAnchor
           (cdkDropListDropped)="drop(level, $event)"
           class="h-[100px] w-full max-w-[300px] flex items-center justify-center bg-white rounded-xl">
        @if (resultsStore.compare_items()[level]; as item) {
          <div cdkDrag [cdkDragData]="item" class="w-full h-full">
            <app-results-footer-compare-card class="fade-slide-in" [level]="level" [item]="item"/>
          </div>
        } @else {
          <div class="bg-white border-2 border-default w-full h-full flex items-center justify-center rounded-lg">
            <div class="select-none">Compare Tires</div>
          </div>
        }
      </div>
    }

    <div class="flex items-center justify-center">
      @if(resultsStore.hasCompareItems()) {
        <div class="inline-block space-y-2">
          <div class="flex items-baseline gap-4">
            <div>
              <app-number [value]="resultsStore.quantity()" (valueChange)="resultsStore.setQuantity(+$event)"
                          label="Qty" [min]="1" [max]="9999" labelBackground="bg-gray-50"/>
            </div>
            <div class="flex">
              <app-button variant="primary" (click)="compareSelected()" [disabled]="!allQuantitiesSourced()" href="compare">
                <app-icons icon="columns-3"/> Compare
              </app-button>
            </div>
          </div>
          <div class="text-right pr-4">
            <span class="cursor-pointer flex items-center justify-end gap-0.5 text-danger" (click)="clearAllSelections()" title="Clear selected compare items">
              <app-icons icon="circle-x" svgClass=""/> Clear
            </span>
          </div>
        </div>
      } @else {
        <div>
          Select up to 3 tires to compare options
        </div>
      }
    </div>
  </div>
</footer>

<app-bottom-drawer [(isOpen)]="isDrawerOpen" class="lg:hidden">
  <div header class="flex items-center gap-2">
    <app-icons icon="columns-3" svgClass=""/>
    <span class="font-semibold">{{ compareItemCount() }} item{{ compareItemCount() > 1 ? 's' : '' }} selected</span>
  </div>

  @if (compareItemCount()) {
    <div class="p-2 space-y-4">
      @for (level of levels; track level) {
        @if (resultsStore.compare_items()[level]; as item) {
          <div>
            <app-results-footer-compare-card [level]="level" [item]="item"/>
          </div>
        }
      }
    </div>

    <div class="p-4 border-t border-gray-200">
      <div class="flex items-center gap-3">
        <div class="w-20">
          <app-number [value]="resultsStore.quantity()" (valueChange)="resultsStore.setQuantity(+$event)"
                      label="Qty" [min]="1" [max]="9999" labelBackground="bg-white"/>
        </div>

        <app-button variant="primary" (click)="compareSelected()" [disabled]="!allQuantitiesSourced()" href="compare" class="flex-1">
          <app-icons icon="columns-3"/> Compare
        </app-button>

        <button (click)="clearAllSelections()" class="text-danger p-2 flex items-center gap-0.5" title="Clear selected compare items">
          <app-icons icon="circle-x" svgClass=""/> Clear
        </button>
      </div>
    </div>
  } @else {
    <div class="pt-2">
      <app-alert variant="instruction">Select up to 3 tires to compare options</app-alert>
    </div>
  }
</app-bottom-drawer>
